import { useMemo } from 'react';
import { selectLocationSearch, useLocationSelector } from '@react-router';
import qs from 'query-string';

// Selected rather than read through `useLocation`: callers only care about the query string, and the
// guest site rewrites the pathname on every scroll step, which would re-render all of them for nothing.
export function useQueryParams(options?: qs.ParseOptions) {
  const search = useLocationSelector(selectLocationSearch);
  // Memoised so callers that pass no options get a stable object: a fresh parse on every render put
  // a new object into their effect dependencies and re-ran the effect for an unchanged query string.
  return useMemo(() => qs.parse(search, options), [search, options]);
}
